import { render, staticRenderFns } from "./bet-board.vue?vue&type=template&id=ae8d42a4&scoped=true"
import script from "./bet-board.vue?vue&type=script&lang=js"
export * from "./bet-board.vue?vue&type=script&lang=js"
import style0 from "./bet-board.vue?vue&type=style&index=0&id=ae8d42a4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae8d42a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae8d42a4')) {
      api.createRecord('ae8d42a4', component.options)
    } else {
      api.reload('ae8d42a4', component.options)
    }
    module.hot.accept("./bet-board.vue?vue&type=template&id=ae8d42a4&scoped=true", function () {
      api.rerender('ae8d42a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tai-xiu/bet-board.vue"
export default component.exports